const DEFAULT_ITEMS = [
  "VOGUE",
  "SAINT LAURENT",
  "BALENCIAGA",
  "CHANEL",
  "HARPER'S BAZAAR",
  "ELLE",
  "GUCCI",
  "DIOR",
  "PRADA",
  "W MAGAZINE",
];

const StarSep = () => (
  <svg viewBox="0 0 24 24" className="h-3 w-3 shrink-0" fill="#D4AF37" aria-hidden="true">
    <path d="M12 0l2.4 9.6L24 12l-9.6 2.4L12 24l-2.4-9.6L0 12l9.6-2.4z" />
  </svg>
);

export const Marquee = ({ items = DEFAULT_ITEMS, className = "" }) => {
  const Row = ({ hidden }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {items.map((b, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap font-display text-2xl font-bold uppercase tracking-tight text-white/20 transition-colors duration-500 hover:text-white/70 sm:text-4xl">
            {b}
          </span>
          <span className="mx-10 flex items-center">
            <StarSep />
          </span>
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden border-y border-white/10 py-6 ${className}`}
    >
      <div className="marquee-track flex w-max">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </div>
  );
};
